import DebtToIncome from './debt-to-income';

export default DebtToIncome;

export {
    DebtToIncome
};
